export default __webpack_public_path__ + "static/media/example-src-bad.08c7e8a3.webp";